export default {"src":"/komodo/_next/static/media/facebook.cf3509a8.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};